import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

const floatingFlags = ['🇲🇾', '🇧🇩', '🇨🇦', '🇬🇧', '🇺🇸', '🇦🇺', '🇩🇪', '🇮🇪', '🇨🇾', '🇲🇹'];

export default function Hero() {
  const particlesRef = useRef(null);

  useEffect(() => {
    const container = particlesRef.current;
    if (!container) return;
    for (let i = 0; i < 30; i++) {
      const dot = document.createElement('div');
      dot.className = 'particle';
      dot.style.left = Math.random() * 100 + '%';
      dot.style.top = Math.random() * 100 + '%';
      dot.style.animationDelay = Math.random() * 5 + 's';
      dot.style.animationDuration = (4 + Math.random() * 4) + 's';
      dot.style.opacity = (0.1 + Math.random() * 0.4).toString();
      container.appendChild(dot);
    }
  }, []);

  return (
    <section className="hero" id="home">
      <div className="particles" ref={particlesRef}></div>
      <div className="hero-bg-orb orb1"></div>
      <div className="hero-bg-orb orb2"></div>
      <div className="hero-bg-orb orb3"></div>

      <div className="hero-inner">
        

        <h1 className="hero-title">
          Study in Malaysia<br />
          <span className="title-outline">Your Dream Awaits</span>
        </h1>

        <p className="hero-subtitle">
          StudiLine is your dedicated partner for studying at <strong>52+ top Malaysian universities</strong>.
          From application to arrival — we handle everything, completely free.
        </p>

        <div className="hero-actions">
          <a href="https://wa.me/601169479883?text=Hi! I want to study in Malaysia. Please help me." target="_blank" rel="noopener noreferrer" className="btn-primary">
            Start Your Journey
            <span className="btn-arrow">→</span>
          </a>
          <Link to="/malaysian-universities" className="btn-secondary">
            View Universities
          </Link>
        </div>

        <div className="country-flags">
          {floatingFlags.map((flag, i) => (
            <span key={i} className="flag-bubble" style={{ animationDelay: `${i * 0.15}s` }}>
              {flag}
            </span>
          ))}
        </div>
      </div>

      <div className="hero-scroll-hint">
        <span>Scroll to explore</span>
        <div className="scroll-line"></div>
      </div>
    </section>
  );
}
